import React from 'react';
import { Box } from '@material-ui/core';

/**
 * Stack Container Component
 * Vertical/horizontal flex layout with configurable gap and alignment
 */
const Stack = ({ children, gap = 16, align = 'stretch', padding = 0, orientation = 'vertical', style, ...props }) => {
  const isHorizontal = orientation === 'horizontal';

  // Map align prop to flex values
  let alignItems = 'stretch';
  if (align === 'center') alignItems = 'center';
  else if (align === 'start' || align === 'left') alignItems = 'flex-start';
  else if (align === 'end' || align === 'right') alignItems = 'flex-end';

  return (
    <Box
      display="flex"
      flexDirection={isHorizontal ? 'row' : 'column'}
      alignItems={alignItems}
      style={{
        gap: `${gap}px`, // Using style gap for flex compatibility
        padding: padding ? `${padding}px` : 0,
        width: '100%',
        boxSizing: 'border-box',
        ...style,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default Stack;
